import { Routes } from '@angular/router'

import { CompanySettingsFilled } from '@@misc/company-settings-filled'
import { SecurityTagGuard } from '@@misc/security-tag-guard'
import { BookingRedirectGuard } from '@@misc/booking-redirect.guard'

import { PortalLayoutComponent } from './layout/portal/portal-layout.component'

import { ServiceUnavailableComponent } from './pages/service-unavailable/service-unavailable.component'
import { CompanyFinderComponent } from './pages/company-finder/company-finder.component'
import { DynamicPageComponent } from './pages/dynamic-page/dynamic-page.component'
import { ZohoSyncComponent } from './pages/zoho-sync/zoho-sync.component'
import { NotfoundComponent } from './pages/notfound/notfound.component'
import { TestComponent } from './pages/test/test.component'
import { PublicLeadFormComponent } from './pages/public-lead-form/public-lead-form.component'
import {
    ClientCompanySettingsComponent
} from './portal/settings/pages/client-company-settings/client-company-settings.component'

export const AppRoutes: Routes = [
    // @web/
    {
        path: '',
        redirectTo: 'portal',
        pathMatch: 'full'
    },

    // @web/portal/
    {
        path: 'portal',
        loadChildren: () =>
            import('./portal/portal.module').then((a) => a.PortalModule)
    },

    // @web/account/
    {
        path: 'account',
        canActivate: [BookingRedirectGuard],
        children: [
            {
                path: '**',
                canActivate: [BookingRedirectGuard],
                component: NotfoundComponent
            }
        ]
    },

    // @web/book/
    {
        path: 'book',
        canActivate: [BookingRedirectGuard],
        children: [
            {
                path: '**',
                canActivate: [BookingRedirectGuard],
                component: NotfoundComponent
            }
        ]
    },

    // @web/azureAD/
    // {
    //     path: 'azureAD',
    //     loadChildren: './projection/azure-ad/azure-ad.module#AzureAdModule'
    // },

    // @web/businessFinder/
    {
        path: 'businessFinder',
        component: CompanyFinderComponent,
        data: {
            title: 'IN2 - Activity',
            isClient: true,
            accountHeader: false,
            accountFooter: false
        }
    },

    // @web/businessFinder/
    {
        path: 'zohoSync',
        component: ZohoSyncComponent,
        resolve: [CompanySettingsFilled],
        canActivate: [SecurityTagGuard],
        data: {
            title: 'Zoho Sync',
            tag: 'ZOHO_SYNC',
            isClient: true,
            accountHeader: false,
            accountFooter: false
        }
    },
    {
        path: "portal/settings",
        component: ClientCompanySettingsComponent,
        data: { title: "Client Company Settings" }
    },

    // @web/page/
    {
        path: 'page/:type',
        component: DynamicPageComponent,
        data: {
            title: 'IN2',
            portalHeader: false,
            portalFooter: false
        }
    },

    // @web/test/
    {
        path: 'test',
        component: PortalLayoutComponent,
        children: [
            // @web/test/
            {
                path: '',
                component: TestComponent,
                data: {
                    title: 'Test',
                    portalHeader: true,
                    portalFooter: false
                }
            }
        ]
    },

    // @web/lead-form/:onlineBookingId - Public lead capture form
    {
        path: 'lead-form/:onlineBookingId',
        component: PublicLeadFormComponent,
        data: {
            title: 'Lead Form',
            portalHeader: false,
            portalFooter: false
        }
    },

    // @web/public/lead-form/:token - Public lead form via trackable link
    {
        path: 'public/lead-form/:token',
        component: PublicLeadFormComponent,
        data: {
            title: 'Lead Form',
            portalHeader: false,
            portalFooter: false,
            isTokenLink: true
        }
    },

    // @web/*
    {
        path: 'serviceUnavailable',
        component: ServiceUnavailableComponent,
        data: {
            title: 'IN2 503 Service Unavailable',
            portalHeader: true,
            portalFooter: false
        }
    },

    {
        path: '**',
        component: NotfoundComponent,
        data: {
            title: 'IN2 404 Not Found',
            portalHeader: true,
            portalFooter: false
        }
    }
]
